export const DashboardTypeEnum = {
  SUPERADMIN: process.env.REACT_APP_DASHBOARD_SUPERADMIN,
  CLIENT: process.env.REACT_APP_DASHBOARD_ADMIN_STK,
  OPERATOR: process.env.REACT_APP_DASHBOARD_OPERATOR_STK,
  GENERIC: process.env.REACT_APP_DASHBOARD_GENERIC,
} as const;

export type DashboardType =
  (typeof DashboardTypeEnum)[keyof typeof DashboardTypeEnum];

export type DashboardTypeKey = keyof typeof DashboardTypeEnum;
